export const formatCurrency = (value, currency = 'USD', locale = 'en-US') => {
  const amount = Number(value)
  const normalized = Number.isFinite(amount) ? amount : 0

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(normalized)
}
